export enum EPixOperationType {
  PIX_KEY = 'PIX_KEY',
  BENEFICIARY = 'BENEFICIARY',
  BANK_DATA = 'BANK_DATA',
  PAMCARD = 'PAMCARD',
  BANK_SLIP = 'BANK_SLIP',
}

export enum ETransactionAccountType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS',
  PAYMENT = 'PAYMENT',
}

export enum EBeneficiaryType {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
}

export enum EPixKeyType {
  CPF = 'CPF',
  CNPJ = 'CNPJ',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  RANDOM = 'RANDOM',
}

interface BaseTransactionPayload {
  value: number;
  transferDate?: string;
  description?: string;
}

export interface IPixKeyTransactionPayload extends BaseTransactionPayload {
  pixKey: string;
}

export interface IBeneficiaryTransactionPayload extends BaseTransactionPayload {
  beneficiaryId: number;
}

export interface IBankDataTransactionPayload extends BaseTransactionPayload {
  taxNumber: string;
  bankCode: string;
  bankBranch: string;
  bankAccount: string;
  accountType: ETransactionAccountType;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IPamcardTransactionPayload extends BaseTransactionPayload {
  // TODO: Define pamcard specific fields
}

export interface IBankSlipTransactionPayload extends BaseTransactionPayload {
  barCode?: string;
  digitableLine?: string;
}

export interface IApproverInfo {
  id: number;
  name: string;
  email: string;
  businessRole?: string | null;
  isApprover: boolean;
}

export interface ITransactionApprovalDetails {
  inclusion: IApproverInfo;
  approver: IApproverInfo | null;
  status: 'APPROVED' | 'REJECTED' | 'PENDING';
}

export interface IBankSlipDebtor {
  name: string;
  document: string;
  postalCode: string;
  publicArea: string;
  number: string;
  neighborhood: string;
  city: string;
  state: string;
}

export interface IBankSlipFine {
  value: number;
  type: 'PERCENT' | 'FIXED';
}

export interface IBankSlipInterest {
  value: number;
  type: 'PERCENT' | 'FIXED';
}

export interface IBankSlipDiscount {
  value: number;
  type: 'PERCENT' | 'FIXED';
  limitDate: string;
}

export interface IBankSlipInstructions {
  fine?: IBankSlipFine;
  interest?: IBankSlipInterest;
  discounts?: IBankSlipDiscount[];
}

export interface ICreateBankSlipRequest {
  amount: number;
  duedate: string;
  debtor: IBankSlipDebtor;
  instructions?: IBankSlipInstructions;
}

export interface IQRCode {
  id: string;
  status: string;
  type: string;
  amount: number | null;
  emvqrcps: string | null;
  // eslint-disable-next-line camelcase
  baasTransactionId: string | null;
  // eslint-disable-next-line camelcase
  createdAt: string;
  // eslint-disable-next-line camelcase
  transactionId: string | null;
}

export interface ICreateQRCodeResponse {
  message: string;
  id: string;
}
